import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getJournalOptions } from '@/module/Journal';
import { JournalImpactFactorView } from '@/module/Journal/JournalImpactFactorView';

export const Route = createFileRoute('/_auth/journal/_journal/$journalId/_layout/impact-factor')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'journals.reputation.impactFactor.view' },
  },
});

function RouteComponent() {
  const { journalId } = Route.useParams();
  const { data: journal } = useSuspenseQuery(getJournalOptions(journalId));

  return (
    <JournalImpactFactorView
      journalId={journalId}
      journalName={journal.title}
    />
  );
}
